/**
 * Anoura — reveal-on-scroll
 * Applies a soft rise/fade to every top-level section as it enters the
 * viewport. Skipped entirely for prefers-reduced-motion users and in
 * browsers without IntersectionObserver.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function observer() {
    if (window.__anouraObserver) return window.__anouraObserver;
    window.__anouraObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            window.__anouraObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -8% 0px' }
    );
    return window.__anouraObserver;
  }

  function init() {
    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;
    var sections = document.querySelectorAll(
      '#MainContent > .shopify-section:not([data-anoura-reveal])'
    );
    var io = observer();
    sections.forEach(function (section) {
      section.setAttribute('data-anoura-reveal', '');
      section.classList.add('anoura-reveal');
      io.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when sections are (re)rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList) {
      event.target.classList.add('is-visible');
    }
    init();
  });
})();
